module.exports = __webpack_public_path__ + "../static/img/logo.e752ff89.png";